import React from 'react';
import type { Chunk } from '@/shared/api/types';
import './ChunksListPanel.scss';

interface ChunksListPanelProps {
  chunks: Chunk[];
  selectedIndex: number;
  onSelect: (index: number) => void;
}

const ChunksListPanel: React.FC<ChunksListPanelProps> = ({
  chunks,
  selectedIndex,
  onSelect
}) => {
  if (chunks.length === 0) {
    return (
      <div className="chunks-list-container empty">
        <div className="empty-message">暂无chunks数据</div>
      </div>
    );
  }

  return (
    <div className="chunks-list-container">
      {chunks.map((chunk) => (
        <div
          key={chunk.chunk_index}
          className={`chunk-item ${chunk.chunk_index === selectedIndex ? 'selected' : ''}`}
          onClick={() => onSelect(chunk.chunk_index)}
        >
          <div className="chunk-header">
            <span className="chunk-index">#{chunk.chunk_index + 1}</span>
            <span className="chunk-size">({chunk.chunk_size} 字符)</span>
            {chunk.has_embedding && (
              <span className="embedding-tag">已向量化</span>
            )}
          </div>
          <div className="chunk-content">
            {chunk.chunk_content}
          </div>
          {chunk.metadata && Object.keys(chunk.metadata).length > 0 && (
            <div className="chunk-metadata">
              元数据: {JSON.stringify(chunk.metadata)}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ChunksListPanel;